import { useEffect } from 'react';

// ─── useEscapeToClose — shared Esc-to-close behavior for modals ───────────────────────────────
// Standing pattern (BUTTON_SYSTEM.md §9, "Pinned-header/footer modal shell"): every modal closes
// on Escape the same way clicking outside or an explicit Cancel button would. `isOpen` guards the
// listener so it's only attached while the modal is actually mounted/open.
export function useEscapeToClose(isOpen: boolean, onClose: () => void) {
  useEffect(() => {
    if (!isOpen) return;
    function handler(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);
}
